export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-11.jpg'),
        title: '数据分析',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '数据加速利润增长，是数字经济时代成功之路',
      description: `<p style="font-size:1.05rem">Maesinfo使用先进的大数据分析技术来加速利润增长并在数字经济时代取得成功。
由于信息不对称（也称为信息失败），传统的商业模式无法掌握精确的用户需求和业务运营的漏洞，造成了大量不必要的损失。
计算机的出现使得能够对大量数据进行计算分析。 借助计算机，通过对数千万用户数据的收集和分析，对数据进行了详细的研究和总结，帮助企业做出更准确的判断和更有效的决策。 这有助于企业实现更高的利润增长，带领他们走向数字经济时代的顶峰。
</p>`
    },
    {
      title: '我们的优势',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-11.jpg')+`)"></span>
      <span>Maesinfo使用最先进的大数据分析技术以及丰富的商业服务经验，通过市场调研收集相关目标数据，分析数据，评估和提高数据分析的有效性。 因此，MaesInfo将帮助您更有效地判断市场趋势，制定适当的生产和销售计划，精确有效，以避免盲目决策和浪费资源。 以最低的成本充分利用您的业务。</span>`
    }
  ]
}
